import {
  CREATE_TEAM,
  GET_ALL_TEAMS,
  GET_TEAM_INFO,
  SET_TEAM_AVATAR,
  UPDATE_TEAM_INFO,
  JOIN_TEAM_REQUEST,
  SET_TEAM_HEADER_IMAGE,
  GET_TEAM_INVITATION_CODE,
} from 'constants/actionTypes';
import Fetch from 'helpers/fetch';

export const fetchAllTeams = () => async (dispatch, getState) => {
  const { auth } = getState();
  const { result } = await Fetch.GET('/matchPoker/getTeams', {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_ALL_TEAMS,
  });
  return result;
};

export const fetchTeamInfo = teamId => async (dispatch, getState) => {
  const { auth } = getState();

  const { result } = await Fetch.GET(`/matchPoker/getTeamInfo?teamId=${teamId}`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: GET_TEAM_INFO,
  });

  return result;
};

export const createTeam = teamName => async (dispatch, getState) => {
  const { auth } = getState();

  const { result } = await Fetch.POST(`/matchPoker/createTeam`, {
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    action: CREATE_TEAM,
    body: { teamName },
  });

  return result;
};

export const fetchTeamInvitationCode = teamId => async (dispatch, getState) => {
  const { teams } = getState();
  const teamToken = teams.info[teamId]?.ownerAccount.token;

  const { result } = await Fetch.GET(`/matchPoker/getTeamInvitationCode`, {
    action: GET_TEAM_INVITATION_CODE,
    headers: { 'x-access-token': teamToken },
  });

  return result?.invitationCode;
};

export const updateTeamInfo = ({ teamId, name, subTitle, description }) => async (
  dispatch,
  getState,
) => {
  const { teams } = getState();
  const teamToken = teams.info[teamId]?.ownerAccount.token;

  const { result } = await Fetch.POST(`/matchPoker/updateTeamInfo`, {
    action: UPDATE_TEAM_INFO,
    headers: { 'x-access-token': teamToken },
    body: { teamName: name, subTitle, description },
  });

  return result;
};

export const joinTeam = invitationCode => async (dispatch, getState) => {
  const { auth } = getState();
  const { result } = await Fetch.POST(`/matchPoker/joinTeam`, {
    action: JOIN_TEAM_REQUEST,
    headers: { 'x-access-token': auth.user?.token || localStorage.getItem('mpToken') },
    body: { invitationCode },
  });

  return result;
};

export const setTeamAvatar = payload => ({
  type: SET_TEAM_AVATAR,
  payload,
});

export const setTeamHeaderImage = payload => ({
  type: SET_TEAM_HEADER_IMAGE,
  payload,
});
